import crypto from 'crypto';
import generateDigest from './crypto';

const HttpSignature = (resource, method, request) => {
  let signatureHeader = '';
  let signatureValue = '';
  const merchantKeyId = '08c94330-f618-42a3-b09d-e1e43be5efda';
  const requestHost = 'apitest.cybersource.com';
  const merchantId = 'testrest';
  const merchantSecretKey = 'yBJxy6LjM2TmcPGu+GaJrHtkke25fPpUX+UY6/L/1tE=';
  let digest = '';
  // KeyId is the key obtained from EBC
  signatureHeader += `keyid="${merchantKeyId}"`;

  // Algorithm should be always HmacSHA256 for http signature
  signatureHeader += ', algorithm="HmacSHA256"';

  if (method === 'get') {
    const headersForGetMethod = 'host (request-target) v-c-merchant-id';
    signatureHeader += `, headers="${headersForGetMethod}"`;
  } else if (method === 'post') {
    const headersForPostMethod = 'host (request-target) digest v-c-merchant-id';
    signatureHeader += `, headers="${headersForPostMethod}"`;
  }

  let signatureString = `host: ${requestHost}`;

  signatureString += '\n(request-target): ';

  if (method === 'get') {
    const targetUrlForGet = `get ${resource}`;
    signatureString += `${targetUrlForGet}\n`;
  } else if (method === 'post') {
    // Digest for POST call
    digest = generateDigest(request);

    const targetUrlForPost = `post ${resource}`;
    signatureString += `${targetUrlForPost}\n`;

    signatureString += `digest: SHA-256=${digest}\n`;
  }

  signatureString += `v-c-merchant-id: ${merchantId}`;

  // eslint-disable-next-line no-buffer-constructor
  const data = Buffer.from(signatureString, 'utf8');

  // Decoding scecret key
  // eslint-disable-next-line no-buffer-constructor
  const key = Buffer.from(merchantSecretKey, 'base64');

  signatureValue = crypto.createHmac('sha256', key).update(data).digest('base64');
  signatureHeader += `, signature="${signatureValue}"`;

  return signatureHeader;
};

export default HttpSignature;
